<template>
    <div class="welcome">
        <v-layout column>
            <v-flex xs12>
                <v-img dark height="250" src="img/page-title-cohorts-5-scaled.jpg">
                    <div align="center" class="font-weight-black mt-16" v-if="currentCompetitors.length==0">
                        <h1>Top 15</h1>
                    </div>
                    <div align="center" class="font-weight-black mt-16" v-if="currentCompetitors.length!=0">
                        <h1>Top {{currentCompetitors.length}}</h1>
                    </div>
                    <div align="center" class="mt-2">
                        Cohort 8
                    </div>

                </v-img>
            </v-flex>
            <v-flex xs12 class="white">
                <v-container class="mt-5">
                    <div v-if="currentCompetitors.length == 0">
                      <v-card
                            class="mx-2 my-4 pa-5 card-soft-glow"
                            elevation="3"
                            color="grey lighten-4"
                            >
                            <v-layout row wrap>
                                <v-flex xs12>
                                <v-card-text>
                                    <!-- Title -->
                                    <div class="text-h6 font-weight-bold mb-4 primary--text announcement-title">
                                    Contestant Announcement Pending
                                    </div>

                                    <!-- Icon and Text -->
                                    <v-layout row align-center justify-center>
                                    <v-flex shrink class="mr-4">
                                        <v-icon class="announcement-icon" size="40px">
                                        mdi-clock-alert-outline
                                        </v-icon>
                                    </v-flex>
                                    <v-flex>
                                        <div class="announcement-text-wrapper">
                                        <div class="announcement-text">
                                            <span>
                                            The top contestants have not yet been announced.<br>
                                            Please check back again soon to see who’s part of WIT Cohort 8.
                                            </span>
                                        </div>
                                        </div>
                                    </v-flex>
                                    </v-layout>
                                </v-card-text>
                                </v-flex>
                            </v-layout>
                            </v-card>

                    </div>
                    <div v-else>
                        <v-layout column>                       
                            <template v-for="(competitor, index) in currentCompetitors">
                                <v-flex xs12 class="mt-2">
                                    <div v-if="index % 2 !== 0">
                                        <template>
                                            <v-card
                                                class="mx-1 my-4 pa-4 card-glow"
                                                elevation="3"
                                                v-scroll-animation
                                            >
                                                <v-layout row wrap align-center>
                                                <!-- Image Section -->
                                                <v-flex xs12 md3>
                                                    <v-img
                                                    height="220"
                                                    :src="path + '/storage/competitor_pics/' + competitor.image"
                                                    class="img-shadow"
                                                    contain
                                                    />
                                                    <div class="d-flex justify-center mt-3 social-bar">
                                                    <template v-for="(icon, key) in socialIcons">
                                                        <a
                                                        v-if="competitor[key] != null"
                                                        :href="competitor[key]"
                                                        target="_blank"
                                                        >
                                                        <v-btn icon class="social-icon">
                                                            <v-icon :color="icon.color" size="24px">{{ icon.name }}</v-icon>
                                                        </v-btn>
                                                        </a>
                                                    </template>
                                                    </div>
                                                </v-flex>

                                                <!-- Info Section -->
                                                <v-flex xs12 md7>
                                                    <v-card-text>
                                                    <div class="text-h6 font-weight-bold primary--text mb-2 text-underline-hover">
                                                        <a :href="competitor.link" target="_blank">{{ competitor.name }}</a>
                                                    </div>
                                                    <v-divider class="my-4 secondary"></v-divider>
                                                    <div class="font-weight-light fade-in-text">
                                                        <div
                                                        v-html="competitor.description"
                                                        class="clamped-description"
                                                        ></div>
                                                    </div>
                                                    </v-card-text>
                                                </v-flex>

                                                <!-- Ranking Badge -->
                                                <v-flex xs12 md2>
                                                    <div class="rank-badge">
                                                    #{{ index + 1 }}
                                                    </div>
                                                </v-flex>
                                                </v-layout>
                                            </v-card>
                                            </template>
                                    </div>
                                    <div v-else>
                                        <template>
                                            <v-card
                                                class="mx-2 my-4 pa-4 card-dark-glow white--text"
                                                elevation="5"
                                                color="grey darken-3"
                                            >
                                                <v-layout row wrap align-center>
                                                <!-- Ranking badge first -->
                                                <v-flex xs2 md2>
                                                    <div class="rank-glow-badge">
                                                    #{{ index + 1 }}
                                                    </div>
                                                </v-flex>

                                                <!-- Info Section -->
                                                <v-flex xs12 md7>
                                                    <v-card-text>
                                                    <div class="text-h6 font-weight-bold mb-2 glow-link">
                                                        <a
                                                        :href="competitor.link"
                                                        target="_blank"
                                                        style="color: #fff; text-shadow: 0 0 3px rgba(0,0,0,0.4); text-decoration: none;"
                                                        >
                                                        {{ competitor.name }}
                                                        </a>
                                                    </div>
                                                    <v-divider class="my-4 primary"></v-divider>
                                                    <div class="font-weight-light fade-slide-text">
                                                        <div
                                                        v-html="competitor.description"
                                                        class="clamped-description"
                                                        ></div>
                                                    </div>
                                                    </v-card-text>
                                                </v-flex>

                                                <!-- Image & socials -->
                                                <v-flex xs12 md3>
                                                    <v-img
                                                    height="220"
                                                    :src="path + '/storage/competitor_pics/' + competitor.image"
                                                    class="img-hover-glow"
                                                    contain
                                                    />
                                                    <div class="d-flex justify-center mt-2 social-neon">
                                                    <template v-for="(icon, key) in socialIcons" >
                                                        <a
                                                        v-if="competitor[key] != null"
                                                        :href="competitor[key]"
                                                        target="_blank"
                                                        >
                                                        <v-btn icon class="neon-icon">
                                                            <v-icon :color="icon.color" size="24px">{{ icon.name }}</v-icon>
                                                        </v-btn>
                                                        </a>
                                                    </template>
                                                    </div>
                                                </v-flex>
                                                </v-layout>
                                            </v-card>

                                            </template>
                                    </div>
                                </v-flex>
                            </template>
                        </v-layout>
                    </div>
                    

                    
                    
                </v-container>
            </v-flex>

            <v-flex xs12>
                <v-img dark height="650" src="img/wit-cohort5-intro.jpg">
                    <v-container class="my-10">
                        <div class="pa-3 mt-16">
                            <p class="white--text headline font-weight-black">
                                Cohort 8 Timeline
                            </p>
                            <p class="white--text text--darken-2">
                            <ul>
                                <li>
                                    <b>Call for applications:</b> April- July 2025
                                </li>
                                <li>
                                    <b>Application Shortlisting:</b> June 2025
                                </li>
                                <li>
                                    <b>Pitch Preparation Bootcamp:</b>  July 2025
                                </li>
                                <li>
                                    <b>Pitches:</b> July 2025
                                </li>
                                <li>
                                    <b>Top 15 Announcements:</b> August 2025
                                </li>
                                <li>
                                    <b>Incubation Phase:</b> August- September 2025
                                </li>
                                <li>
                                    <b>Masterclasses:</b> August- October 2025
                                </li>
                                <li>
                                    <b>Mentoring:</b> August 2025- Ongoing
                                </li>
                                <li>
                                    <b>Coaching:</b> September 2025
                                </li>
                                <li>
                                    <b>Demo Day:</b> November 2025
                                </li>
                                <li>
                                    <b>Top 7 Award Ceremony:</b> November 2025
                                </li>
                                <li>
                                    <b>Post Incubation Support:</b> December 2025
                                </li>
                            </ul>
                            </p>
                            <!-- <p class="white--text text--darken-2 mt-10">
                                <b>Date:</b> Applications Ongoing
                            </p>
                            <p class="white--text text--darken-2">
                                <b>Time:</b> Deadline for application 28th May 2023
                            </p> -->
                        </div>
                    </v-container>

                </v-img>
            </v-flex>
        </v-layout>
    </div>
</template>
<style>
/* <-- remove scoped here if you have it*/
.v-carousel__controls {
    background: #fff !important;
    border-radius: 25px;
}

.v-carousel__controls__item {
    color: #007932 !important;
}
</style>
<script>
import apiCall from "@/utils/api";
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VClamp from "vue-clamp";

export default {
    components: {

    },
    data() {
        return {
            path: process.env.VUE_APP_API_URL,
            color: "",
            message: "",
            snackbar: false,
            drawer: false,

            absolute: true,
            overlay: true,
            opacity: 0.3,

           socialIcons: {
                facebook_url: { name: "mdi-facebook", color: "#3b5998" },
                x_url: { name: "mdi-twitter", color: "#1DA1F2" },
                instagram_url: { name: "mdi-instagram", color: "#8a3ab9" },
                linkedin_url: { name: "mdi-linkedin", color: "#0e76a8" },
                link: { name: "mdi-web", color: "secondary" },
                youtube_url: { name: "mdi-youtube", color: "#cc181e" },
            }



        };
    },
    mounted() {
        window.onscroll = () => {
            this.changeColor();
        };
    },
    created() {
        window.scrollTo(0, 0);
        this.changeHeaderColor("white");
        this.changeTitleColor("red--text");
        this.changeButtonColor("red--text hidden-sm-and-down text-none caption");

        this.getCompetitors()
    },
    methods: {
        ...mapActions([
            "changeHeaderColor",
            "changeTitleColor",
            "changeButtonColor",
            "filterCurrentCompetitors",
            "startCompetitorLoader",
            "stopCompetitorLoader"
        ]),
        changeColor() {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                this.changeHeaderColor("white");
                this.changeTitleColor("white--text");
                this.changeButtonColor("white--text hidden-sm-and-down text-none caption");
            } else {
                this.changeHeaderColor("white");
                this.changeTitleColor("white--text");
                this.changeButtonColor("white--text hidden-sm-and-down text-none caption");
            }
        },

        getCompetitors() {
			this.startCompetitorLoader()
			apiCall({
				url     : "/api/competitor?type=current",
				method  : "GET",
			})
				.then((resp) => {
					this.filterCurrentCompetitors(resp);
					this.stopCompetitorLoader()
				})
				.catch((error) => {
					this.message = "An Error Occurred";
					this.color = "error";
					this.snackbar = true;
					this.stopCompetitorLoader()
				});
		},
        removeTags(str) {
			if ((str===null) || (str===''))
				return false;
			else
				str = str.toString();
			return str.replace( /(<([^>]+)>)/ig, '');
		}
    },
    computed: {
        ...mapGetters([
            "darkState",
            "currentCompetitors",
            "competitorLoader"
        ]),
    },
};
</script>
<style scoped>
.card-glow {
  transition: box-shadow 0.3s ease-in-out;
  border-radius: 12px;
}
.card-glow:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.img-shadow {
  border-radius: 8px;
  transition: transform 0.4s ease;
}
.img-shadow:hover {
  transform: scale(1.05);
}

.social-bar .social-icon {
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0.7;
}
.social-bar .social-icon:hover {
  transform: scale(1.2);
  opacity: 1;
}

.text-underline-hover a {
  text-decoration: none;
  transition: border-bottom 0.2s ease;
}
.text-underline-hover a:hover {
  border-bottom: 2px solid currentColor;
}

.fade-in-text {
  animation: fadeIn 0.6s ease forwards;
}

.clamped-description {
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
}

.rank-badge {
  font-size: 36px;
  font-weight: 900;
  color: #ff5722;
  font-style: italic;
  text-align: center;
  animation: pulse 1.2s infinite ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.1); opacity: 1; }
}


.card-dark-glow {
  border-radius: 12px;
  transition: box-shadow 0.3s ease;
}
.card-dark-glow:hover {
  box-shadow: 0 12px 30px rgba(255, 255, 255, 0.1);
}

.rank-glow-badge {
  font-size: 36px;
  font-weight: 900;
  color: #ff9800;
  text-shadow: 0 0 8px #ff9800;
  font-style: italic;
  animation: pulseGlow 1.4s infinite ease-in-out;
  text-align: center;
}

.img-hover-glow {
  border-radius: 8px;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}
.img-hover-glow:hover {
  transform: scale(1.05);
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.2);
}

.social-neon .neon-icon {
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0.7;
}
.social-neon .neon-icon:hover {
  transform: scale(1.2);
  opacity: 1;
  filter: drop-shadow(0 0 6px currentColor);
}

.glow-link a {
  color: #ffc107;
  text-decoration: none;
  transition: all 0.3s ease;
}
.glow-link a:hover {
  text-shadow: 0 0 8px #ffc107;
  border-bottom: 1px solid #ffc107;
}

.fade-slide-text {
  animation: fadeSlideIn 0.7s ease forwards;
}

.clamped-description {
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
}

@keyframes pulseGlow {
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.1); opacity: 1; }
}

@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

.card-soft-glow {
  border-radius: 12px;
  transition: box-shadow 0.4s ease;
}
.card-soft-glow:hover {
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.08);
}

.announcement-title {
  text-align: center;
  animation: fadeInDown 0.6s ease;
}

.announcement-icon {
  color: #ff9800;
  transition: transform 0.3s ease;
}
.announcement-icon:hover {
  transform: scale(1.2);
}

.announcement-text-wrapper {
  max-width: 500px;
  margin: 0 auto;
}

.announcement-text {
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
  font-weight: 300;
  animation: fadeSlideIn 0.8s ease forwards;
  color: #424242;
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}


</style>
